import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";
import { MapPin } from "lucide-react";

export const LOCATION_DISCLOSURE_KEY = "fieldz_location_disclosure_accepted";

export const hasAcceptedLocationDisclosure = () =>
  localStorage.getItem(LOCATION_DISCLOSURE_KEY) === "1";

// Prominent disclosure required by Google Play / App Store policies —
// must be shown BEFORE the system location permission prompt.
const LocationDisclosureDialog = ({ open, onAccept, onCancel }) => (
  <AlertDialog open={open}>
    <AlertDialogContent className="max-w-md" data-testid="location-disclosure-dialog">
      <AlertDialogHeader>
        <div className="mx-auto w-12 h-12 rounded-full bg-green-500/10 flex items-center justify-center mb-2">
          <MapPin className="w-6 h-6 text-green-500" />
        </div>
        <AlertDialogTitle className="text-center">Location sharing</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="text-sm text-muted-foreground space-y-2 text-left">
            <p>
              <strong className="text-foreground">Fieldz AI collects location data</strong> to
              share your live position with your company's managers and dispatchers, so they can
              see who is nearby and coordinate jobs.
            </p>
            <p>
              While location sharing is ON, your location is collected{" "}
              <strong className="text-foreground">
                even when the app is in the background or not in use
              </strong>
              . It is visible only to authorized members of your company and is never used for
              advertising.
            </p>
            <p>
              Sharing stops as soon as you turn it off or log out, and you can change this anytime
              from your profile.
            </p>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="flex-col sm:flex-col gap-2">
        <Button className="w-full" onClick={onAccept} data-testid="location-disclosure-accept">
          Turn on location sharing
        </Button>
        <Button variant="ghost" className="w-full" onClick={onCancel} data-testid="location-disclosure-decline">
          Not now
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default LocationDisclosureDialog;
